import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Home from './pages/Home/Home/Home';
import Navigation from './pages/Shared/Navigation/Navigation';
import Footer from './pages/Shared/Footer/Footer';
import About from './pages/About/About/About';
import WhyTrustUs from './pages/WhyTrustUs/WhyTrustUs/WhyTrustUs';
import OurWork from './pages/OurWork/OurWork/OurWork';
import Services from './pages/Services/Services/Services';
import ServiceDetails from './pages/Services/ServiceDetails/ServiceDetails/ServiceDetails';
import MessengerCustomerChat from 'react-messenger-customer-chat';


function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Navigation />
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/:serviceId" element={<ServiceDetails />} />
          <Route path="/trust_us" element={<WhyTrustUs />} />
          <Route path="/our_work" element={<OurWork />} />
        </Routes>
        <Footer />
      </BrowserRouter>
      <MessengerCustomerChat pageId="101736695727292" appId="235899308586271" />
    </div>
  );
}

export default App;
